import u from "./index344.mjs";
import W from "./index286.mjs";
import s from "./index210.mjs";
import m from "./index212.mjs";
function c(n, e) {
  m(1, arguments);
  var t = e || {}, r = t.locale, o = r && r.options && r.options.firstWeekContainsDate, i = o == null ? 1 : s(o), f = t.firstWeekContainsDate == null ? i : s(t.firstWeekContainsDate), l = u(n, e), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(l, 0, f), a.setHours(0, 0, 0, 0);
  var k = W(a, e);
  return k;
}
export {
  c as default
};
//# sourceMappingURL=index335.mjs.map
